<main class="layout-wrapper">
  <div class="layout">
    <header class="header">
      <button class="mobile-toggle" data-testid="nav-header-mobile-toggle-btn" (click)="toggleMobile()">☰</button>
      <a href="javascript:void(0)" class="logo flex-section gap-2 py-4" data-testid="nav-header-logo-link" routerLink="/dashboard">
        <img src="assets/img/layout/logo.svg" className="w-[48px]" />
        <div class="logo-text">
          <h3>FoodTraze <span class="font-normal text-xs relative">™</span> </h3>
          <p>
            {{ 'LAYOUT.BLOCKCHAIN_TAGLINE' | translate }}
          </p>
        </div>
      </a>

      <div class="right">
        <div class="role-badge" data-testid="nav-header-role-badge">
          <img [src]="orgTypeIcon" alt="">
          <span>{{ aliasOrg }}</span>
        </div>

        <div class="btn-group">
          <button type="button" class="dropdown-toggle" data-testid="nav-header-lang-dropdown" data-bs-toggle="dropdown">
            <img src="assets/img/layout/globe.svg" alt="">
            {{ selectedLang.toUpperCase() }} - {{ selectedLangName }}
          </button>

          <ul class="dropdown-menu dropdown-menu-end">

            @for (lang of languages; track lang) {
            <li>
              <a class="dropdown-item" [attr.data-testid]="'nav-header-lang-' + lang.code + '-link'" [class.selected]="selectedLang === lang.code" (click)="changeLanguage(lang)">
                {{ lang.code.toUpperCase() }} - {{ lang.name }}
              </a>
            </li>
            }

          </ul>
        </div>

        <div class="btn-group">
          <button type="button" class="dropdown-toggle" data-testid="nav-header-user-dropdown" data-bs-toggle="dropdown" aria-expanded="false">
            @if (userProfileImage) {
            <img [src]="userProfileImage" crossorigin="anonymous" class="profile-img" alt="profile">
            } @else {
            <span class="profile">{{ userInitials }}</span>
            }
            <span class="text">{{ userName }}</span>
          </button>
          <ul class="dropdown-menu dropdown-menu-end">

            <li>
              <a class="dropdown-item" data-testid="nav-header-user-profile-link" routerLink="/my-profile">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M13.3327 14V12.6667C13.3327 11.9594 13.0517 11.2811 12.5516 10.781C12.0515 10.281 11.3733 10 10.666 10H5.33268C4.62544 10 3.94716 10.281 3.44706 10.781C2.94697 11.2811 2.66602 11.9594 2.66602 12.6667V14M10.666 4.66667C10.666 6.13943 9.47211 7.33333 7.99935 7.33333C6.52659 7.33333 5.33268 6.13943 5.33268 4.66667C5.33268 3.19391 6.52659 2 7.99935 2C9.47211 2 10.666 3.19391 10.666 4.66667Z"
                    stroke="#1E1E1E" stroke-linecap="round" stroke-linejoin="round" />
                </svg>

                {{ 'MY_PROFILE.TITLE' | translate }}
              </a>
            </li>

            <li>
              <a href="javascript:void(0)" class="dropdown-item" data-testid="nav-header-user-password-link" (click)="openPasswordModal()">
                <img src="assets/img/layout/lock.svg">
                {{ 'PASSWORD' | translate }}
              </a>
            </li>

            <li>
              <a class="dropdown-item" data-testid="nav-header-user-logout-link" (click)="logout()" style="cursor:pointer">
                <img src="assets/img/layout/logout.svg">
                {{ 'LOGOUT' | translate }}
              </a>
            </li>

          </ul>
        </div>
      </div>
    </header>

    <div class="body">
      <aside class="sidebar" data-testid="nav-sidebar-container" [class.expanded]="isExpanded" [class.mobile-open]="isMobileOpen"
        (mouseenter)="onDesktopEnter()" (mouseleave)="onDesktopLeave()">
        <nav class="menu">
          @for (menu of menus; track menu.label) {
          @if (!menu.permission || hasPermission(menu.permission)) {

          <!-- Parent -->
          @if (!menu.children) {
          <a class="menu-item" [attr.data-testid]="'nav-sidebar-menu-' + (menu.route?.replace('/', '') || menu.key) + '-link'" [routerLink]="menu.route" routerLinkActive="active"
            (click)="onMenuClick(menu)">
            <span class="menu-icon">
              <img [src]="menu.icon">
            </span>

            <span class="label">
              {{ menu.label | translate }}
            </span>
          </a>

          } @else {

          <a class="menu-item" [attr.data-testid]="'nav-sidebar-menu-' + menu.key + '-dropdown'" [class.open]="isOpen(menu.key)" [class.active]="menu.active?.()"
            (click)="toggleMenu(menu.key)">

            <span class="menu-icon">
              <img [src]="menu.icon">
            </span>

            <span class="label">
              {{ menu.label | translate }}
            </span>

            <span class="accordion-arrow label">
              <img src="assets/image/active-arrow.svg" class="arrow-icon" [class.rotated]="isOpen(menu.key)">
            </span>
          </a>

          @if (isExpanded && isOpen(menu.key)) {
          <div class="accordion-body" [class.expanded-body]="isOpen(menu.key)">
            @for (child of menu.children; track child.route) {
             @if (child.modal) {
            <a class="menu-item sub-item" data-testid="nav-sidebar-menu-access-key-link" (click)="openAccessKeyModal(); closeMobile()">
              <span class="menu-icon">
                <img [src]="child.icon">
              </span>

              <span class="label">
                {{ child.label | translate }}
              </span>
            </a>
            } @else {
            <a class="menu-item sub-item" [attr.data-testid]="'nav-sidebar-menu-' + (child.route?.replace('/', '') || 'sub') + '-link'" [routerLink]="child.route" routerLinkActive="active" (click)="closeMobile()">
              <span class="menu-icon">
                <img [src]="child.icon">
              </span>

              <span class="label">
                {{ child.label | translate }}
              </span>
            </a>
            }
          }
          </div>
          }
          }
          }
          }
        </nav>

      </aside>


      <main class="content">
        <router-outlet></router-outlet>
      </main>
    </div>

    @if (showFooter) {
    <footer class="footer">
      <div class="footer__left">
        <p>{{ 'LAYOUT.FOOTER_VERSION' | translate }}</p>
      </div>
      <div class="footer__right">
        {{ 'LAYOUT.FOOTER_COPYRIGHT' | translate }}
      </div>
    </footer>
    }

    @if (isMobileOpen) {
    <div class="backdrop" (click)="closeMobile()"></div>
    }
  </div>


  <aside class="support-sidebar" [class.show]="isHighlighted" [class.compact-support-sidebar]="isCompactSupportSidebar">
    <header class="support-header">
      <div class="header-main">
        <div class="help-badge">
          <svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z"
              fill="white" fill-opacity="0.2" />
            <path
              d="M17.29 17.1992C17.5251 16.5309 17.9891 15.9673 18.5999 15.6084C19.2107 15.2494 19.9288 15.1182 20.6271 15.2379C21.3254 15.3577 21.9588 15.7207 22.415 16.2627C22.8713 16.8048 23.121 17.4907 23.12 18.1992C23.12 20.1992 20.12 21.1992 20.12 21.1992M20.2 25.1992H20.21M30.2 20.1992C30.2 25.7221 25.7228 30.1992 20.2 30.1992C14.6771 30.1992 10.2 25.7221 10.2 20.1992C10.2 14.6764 14.6771 10.1992 20.2 10.1992C25.7228 10.1992 30.2 14.6764 30.2 20.1992Z"
              stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
        <div class="header-titles">
          <h2>Help & Support</h2>
        </div>
        <button class="close-btn" data-testid="layout-support-close-btn" aria-label="Close panel" (click)="closeModal()">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 5L5 15" stroke="white" stroke-opacity="0.8" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M5 5L15 15" stroke="white" stroke-opacity="0.8" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </button>
      </div>
    </header>

    <div class="support-body" #supportBody>
      <section class="walkthrough-section">
        <div>
          <h3 class="section-title">{{ helpSectionTitle }}</h3>
          <div class="section-para">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M12.7501 13.916L13.9167 12.7493L10.8334 9.66602V5.83268H9.16675V10.3327L12.7501 13.916ZM10.0001 18.3327C8.8473 18.3327 7.76397 18.1139 6.75008 17.6764C5.73619 17.2389 4.85425 16.6452 4.10425 15.8952C3.35425 15.1452 2.7605 14.2632 2.323 13.2493C1.8855 12.2355 1.66675 11.1521 1.66675 9.99935C1.66675 8.84657 1.8855 7.76324 2.323 6.74935C2.7605 5.73546 3.35425 4.85352 4.10425 4.10352C4.85425 3.35352 5.73619 2.75977 6.75008 2.32227C7.76397 1.88477 8.8473 1.66602 10.0001 1.66602C11.1529 1.66602 12.2362 1.88477 13.2501 2.32227C14.264 2.75977 15.1459 3.35352 15.8959 4.10352C16.6459 4.85352 17.2397 5.73546 17.6772 6.74935C18.1147 7.76324 18.3334 8.84657 18.3334 9.99935C18.3334 11.1521 18.1147 12.2355 17.6772 13.2493C17.2397 14.2632 16.6459 15.1452 15.8959 15.8952C15.1459 16.6452 14.264 17.2389 13.2501 17.6764C12.2362 18.1139 11.1529 18.3327 10.0001 18.3327ZM10.0001 16.666C11.8473 16.666 13.4202 16.0167 14.7188 14.7181C16.0174 13.4195 16.6667 11.8466 16.6667 9.99935C16.6667 8.15213 16.0174 6.57921 14.7188 5.2806C13.4202 3.98199 11.8473 3.33268 10.0001 3.33268C8.15286 3.33268 6.57994 3.98199 5.28133 5.2806C3.98272 6.57921 3.33341 8.15213 3.33341 9.99935C3.33341 11.8466 3.98272 13.4195 5.28133 14.7181C6.57994 16.0167 8.15286 16.666 10.0001 16.666Z"
                fill="#171F26" fill-opacity="0.8" />
            </svg>

            <p>{{ helpReadTime }}</p>
          </div>

          <p class="section-para2">{{ helpSectionIntro }}</p>

          @if (isHighlighted && (helpPageContext === 'user' || helpPageContext === 'create-user')) {
          <div class="step-details-video">
            <iframe [src]="supportVideoUrl" frameborder="0" allowfullscreen>
            </iframe>
          </div>
          }

        </div>
        <div class="accord" id="accordionExample">

          @for (section of supportSections; track section.id; let i = $index) {

          <div class="accordion-itm accordion-panel main-walkthrough">

            <button class="accordion-trigger p-0" [attr.data-testid]="'layout-support-section-' + section.id + '-btn'" type="button" data-bs-toggle="collapse"
              [attr.data-bs-target]="'#' + section.id" [attr.aria-controls]="section.id" [attr.aria-expanded]="i === 0">

              <summary class="accordion-trigger">
                <span>{{ section.title }}</span>

                <svg class="chevron" width="14" height="14" viewBox="0 0 14 14" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path d="M3.5 5.25L7 8.75L10.5 5.25" stroke="#6A7581" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>

              </summary>

            </button>

            <div class="accordion-collapse collapse" [id]="section.id" [class.show]="i === 0"
              data-bs-parent="#accordionExample">

              <div class="accordion-content">

                <ol class="step-list">
                  @for (step of section.steps; track $index) {
                  <li class="step-item">
                    <div class="step-details">
                      <h4>{{ step.title }} <svg width="12" height="12" viewBox="0 0 12 12" fill="none"
                          xmlns="http://www.w3.org/2000/svg">
                          <g clip-path="url(#clip0_5136_3525)">
                            <g clip-path="url(#clip1_5136_3525)">
                              <path
                                d="M6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1C3.23858 1 1 3.23858 1 6C1 8.76142 3.23858 11 6 11Z"
                                stroke="#2BAB6F" stroke-opacity="0.6" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" />
                              <path d="M4.5 6L5.5 7L7.5 5" stroke="#2BAB6F" stroke-opacity="0.6" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round" />
                            </g>
                          </g>
                          <defs>
                            <clipPath id="clip0_5136_3525">
                              <rect width="12" height="12" fill="white" />
                            </clipPath>
                            <clipPath id="clip1_5136_3525">
                              <rect width="12" height="12" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </h4>

                      <ul class="description-list">
                        @for (desc of step.description; track $index) {

                        @if (desc.text) {
                        <li>{{ desc.text }}</li>
                        }

                        @if (desc.heading) {
                        <li>
                          <strong>{{ desc.heading }}</strong>

                          <ul class="sub-description-list">
                            @for (item of desc.items; track $index) {
                            <li>{{ item }}</li>
                            }
                          </ul>
                        </li>
                        }

                        }
                      </ul>

                    </div>
                  </li>
                  }
                </ol>

              </div>

            </div>

          </div>

          }

        </div>
      </section>
    </div>

  </aside>



</main>